import { InputDashboard } from "./InputDashboard";
import { Content } from "@/components/ui/ContentArea";

export function InputPage() {
	return (
		<Content className="p-5">
			<title>Editar Referencias Consumo</title>
			<InputDashboard />
		</Content>
	);
}
